import React from "react";
import { forwardRef } from "react";

const MFElssReportTable = forwardRef(
  (
    {
      tableData,
      handleTableScroll,
      scrollLoaderTable,
      loader,
      LoaderForSearch,
      clientDashboard,
    },
    ref
  ) => {
    return (
      <div className="table-responsive scroll-table report-table-wrapper">
      <table className="table last-column">
        <thead>
          <tr>
            <th scope="col" className={clientDashboard ? "text-center" : ""}>
              Sr No.
            </th>
            <th scope="col">
             NAV Date
            </th>
            <th scope="col">
              Scheme Name
            </th>
            <th scope="col">
              Folio Number
            </th>
            <th scope="col">
              Units
            </th>
            <th scope="col">
              Amount
            </th>
            <th scope="col">
              Category
            </th>
            
            {/* {hasVerticalScroll && <th className="scrollerthead"></th>} */}
          </tr>
        </thead>
        <tbody
          onScroll={(e) => handleTableScroll(e)}
          // id="per-table-body"
          ref={ref}
        >
          {tableData?.length > 0 &&
            tableData.map((item, index) => {
              return (
                <tr key={index}>
                  <td className={clientDashboard ? "text-center" : ""}>
                    {index + 1}
                  </td>
                  <td>{item?.navDate}</td>
                  <td>{item?.schemeName || "-"}</td>
                  <td>{item?.folioNo || "-"}</td>
                  <td>{item?.units || "-"}</td>
                  <td>{item?.amount || "-"}</td>
                  <td>{item?.category || "-"}</td>
                  {/* <td></td> */}
                </tr>
              );
            })}
          
        </tbody>
        {scrollLoaderTable && !loader && (
            <div className="loader-center">
              <LoaderForSearch />
            </div>
          )}
      </table>
      </div>
    );
  }
);

export default MFElssReportTable;
